import Board from './Board.component';

export default Board;
